import { atom, selector } from 'recoil'

import { pageState } from 'State/page'

export const recipientState = atom({
  key: 'recipientsClickRecipientState',
  default: {
    recipientProfile: {},
    loaded: false,
    channel: '',
  },
})

export const tableStateSerach = atom({
  key: 'recipientsClickTableStateSerach',
  default: {
    orderBy: 'ClickOrderbyDate',
    orderDescending: true,
    pageSize: 10,
    pageNumber: 1,
  },
})

export const tableStateResult = atom({
  key: 'recipientsClickTableStateResult',
  default: {
    items: [],
    totalItems: 0,
    loading: true,
  },
})

export const tableLoadingState = atom({
  key: 'recipientsClick_tableLoadingState',
  default: true,
})

export const resultsStateEmptyState = selector({
  key: 'recipientsClickEmptyState',
  get: ({ get }) => {
    const {
      totalItems,
      // searchState: { alias, status }
    } = get(tableStateResult)

    const { status } = get(pageState)

    return status === 'ready' && totalItems === 0
  },
})
